import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  hideHeaderPlugin,
  showHeaderPlugin,
} from 'utils/disclosure-analytics-utils';

const PublicRoute = ({ component: Component }) => {
  useEffect(() => {
    hideHeaderPlugin();

    return () => {
      showHeaderPlugin();
    };
  }, []);

  return <Component />;
};

PublicRoute.propTypes = {
  /**React component to be rendered in the public route component */
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType])
    .isRequired,
};

export default PublicRoute;
